import { Component, h, getAssetPath } from '@stencil/core';

@Component({
  tag: 'pennlibs-fallback-img',
  styleUrl: 'pennlibs-fallback-img.css',
  shadow: true,
  assetsDirs: ['assets']
})
export class NoImage {
  render() {
    const shieldImg = getAssetPath('./assets/simplified-shield.webp');

    return (
      <img src={shieldImg} alt="" class="no-image__img" />
    );
  }
} 